const CONECCTIONSVIEW = {
  company: "Company",
  typeConnection: "Connection type",
  motorConnection: "Connection engine",
  nameConnection: "Connection name:",
  user: "User",
  password: "Password",
  dataBase: "Database",
  host: "Host",
  idProject: "Project ID",
  idProjectGCP: "Project ID (GCP)",
  nameInstance: "Instance Name",
  examplePlaceHolder: "Example: instance:zone",
  update: "To update",
  create: "To create",
  restore: "Restore",
  cancel: "Cancel",
  managerConnection: "Connection Manager",
  selectCompany: "Select a Company to continue",
  selectTypeConnection: "Select a connection type",
  selectMotorConnection: "Select a connection engine to continue",
  enterNameConnecction: "Enter the name of the connection",
  manageKeys: "Key Manager",
  validateNameConnection: "Enter a valid login name (at least 3 characters)",
  validateNameUser: "Enter a username (at least 3 characters)",
  validateKeys: "Enter a valid password (at least 6 characters)",
  validateNameDB: "Enter a valid database name (at least 3 characters)",
  host: "Host",
  enterIpHost: "Enter the IP of the host.",
  validateIpHost: "Enter a valid IP for the host.",
  pahtConnection: "Connection path",
  selectFormConecction: "Select the connection form.",
  nameProject: "Project's name",
  validateIdProyect: "Enter the project ID (at least 6 characters)",
  nameInstance: "instance name",
  validateInstane: "Please enter a valid instance name (at least 3 characters)",
  errorSaveConnection: "An error occurred while saving the connection({error})",
  updateConnection: "Connection updated successfully!",
  emptyCompanies: "There are no registered companies.",
  listCompanies: "List of companies",
  _updateConnection: "Updating Connection",
  _newConnection: "New connection",

  name: "Name",
  company: "Company",
  type: "Type",
  actions: "Actions",
  emptyConnections: "There are no registered connections.",
  listConnections: "Connections List",
  deleteConnection: "Delete Connection: {data}",
  advertencie: "This option cannot be undone, are you sure?",
  accept: "To accept",
  titleDeleteConnection: "Delete Connection",
  errorToDelecteConnection: "An error occurred while deleting the Connection",
  actionDisabled: "Action not available at the moment"
};

export default { CONECCTIONSVIEW };
